module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\n\nvoid main() {\n\n\tvUv = uv;\n\n\tgl_Position = vec4( position, 1.0 );\n\tgl_Position.z = 1.0;\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderLib/background_vert.glsl
// module id = 296
// module chunks = 0